// src/config/seoConfig.js
export const seoData = {
  home: {
    title: "Alchemity | Turning waste to net-zero fuels at lower cost",
    description:
      " Alchemity is transforming greenhouse gases and waste into sustainable aviation fuel (SAF), hydrogen, and chemicals using a modular, zero-emissions reactor system.",
    keywords:
      "Alchemity, sustainable fuels, SAF, hydrogen, clean technology, modular reactor, waste to fuel, net-zero chemicals, chemical conversion, carbon-free, clean energy organization, maryland clean energy startup, college park startup ",
    image: "/images/alchemity_logo_w_text.png",
  },
  about: {
    title: "About Alchemity | Meet the Team Behind the Clean Tech Revolution",
    description:
      " Discover Alchemity's leadership, mission, and vision to decarbonize fuels and chemical production through modular, scalable innovation. ",
    keywords:
      "Alchemity team, alchemity leaders, clean energy founders, sustainable innovation, net-zero technology leaders",
    image: "/images/about3.png",
  },
  products: {
    title:
      "Alchemity Products | Modular Skids for Clean Fuel and Chemical Production",
    description:
      "Deploy Alchemity's plug-and-play modular reactor systems for on-site, clean production of SAF, hydrogen, and chemicals at reduced cost.",
    keywords:
      "alchemity products, modular reactor skids, chemical production, SAF systems, clean fuel technology, biomethane processing",
    image: "/images/companal.png",
  },
  technology: {
    title: "Technology | Zero-Emission Chemical Conversion with Alchemity",
    description:
      " Explore Alchemity’s advanced mixed-conducting ceramic reactor that enables direct conversion of biogas and waste to valuable products without carbon-dioxide emissions. ",
    keywords:
      "chemical technology, reactor systems, clean technology, innovation, clean technology, zero-emission reactor, methane conversion, ceramic membranes, chemical innovation",
    image: "/images/technology_metadata_img.png",
  },
  markets: {
    title: "Alchemity Markets | SAF, Hydrogen, and Circular Chemicals",
    description:
      " Alchemity is strategically targeting high-impact sectors like aviation, waste management, and chemical production with scalable net-zero solutions and a turnkey Modular Platform System integration.",
    keywords:
      "chemical markets, SAF market, hydrogen economy, circular chemistry, waste-to-fuel, low-carbon markets, sustainable fuels",
    image: "/images/markets_metadata_img.png",
  },
  careers: {
    title: "Careers at Alchemity | Build the Future of Clean Chemicals",
    description:
      "Join Alchemity's growing team and help develop breakthrough chemical technologies. Explore open roles in engineering, R&D, and commercialization.",
    keywords:
      "alchemity careers, chemical engineering jobs, clean technology careers, innovation jobs, careers in clean tech, chemical engineer roles, green technology jobs, saf companies, saf startups, clean hydrogen companies, climatetech hiring",
    image: "",
  },
  contact: {
    title: "Contact Alchemity | Partner with Us on the Path to Net-Zero",
    description:
      "Get in touch with us to discuss partnerships, investment, or product inquiries. We’re building the next generation of clean chemical systems.",
    keywords:
      "contact alchemity, partnership inquiries, chemical technology work, clean energy partnerships, SAF inquiries, chemical technology collaboration ",
    image: "",
  },
  news: {
    title: "Alchemity News | Clean Tech Announcements and Industry Updates",
    description:
      "Learn about Alchemity's milestones, pilot deployments, media mentions, and research breakthroughs in clean fuels.",
    keywords:
      "alchemity news, chemical technology news, clean energy updates, research breakthroughs",
    keywords:
      "alchemity news, chemical technology news, clean energy updates, research breakthroughs, net-zero innovation, SAF news updates, clean fuel announcements, clean energy press releases ",
    image: "",
  },
};
